import { render, staticRenderFns } from "./ChangeAccountPopup.vue?vue&type=template&id=63d153b8"
import script from "./ChangeAccountPopup.vue?vue&type=script&lang=js"
export * from "./ChangeAccountPopup.vue?vue&type=script&lang=js"
import style0 from "./ChangeAccountPopup.vue?vue&type=style&index=0&id=63d153b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports